import config, { AUTO_GRANT_CONSENT } from "@/config/config";
import {
  ErrorBoundary,
  init,
  replayIntegration,
  tanstackRouterBrowserTracingIntegration,
} from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import { queryClient } from "./api/query-client";
// import ConsentButton from "./components/Cookies/consentButton";
import "./i18n";

import { routeTree } from "./routeTree.gen";

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

function render() {
  root.render(
    <ErrorBoundary fallback={<div>An error has occurred</div>}>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          {/* <ConsentButton /> */}
          {/* <InstallButton /> */}
          <ToastContainer />
        </QueryClientProvider>
      </HelmetProvider>
    </ErrorBoundary>,
  );
}

const grantTikTokConsent = () => {
  window.ttq?.grantConsent();
};

const initializeAnalytics = () => {
  if (AUTO_GRANT_CONSENT && typeof window !== "undefined") {
    try {
      localStorage.setItem("cookie_consent", "true");
      if (window.gtag) {
        window.gtag("consent", "update", {
          analytics_storage: "granted",
          ad_storage: "granted",
          ad_user_data: "granted",
          ad_personalization: "granted",
        });
        window.gtag("config", "G-2H8P3FCSEL");
        window.gtag("config", "AW-1013168892");
      }
      if (window.ttq) {
        grantTikTokConsent();
      } else {
        window.addEventListener("load", grantTikTokConsent, { once: true });
      }
    } catch (e) {
      // localStorage not available (SSR)
    }
  }
};

const initializeSentry = () => {
  init({
    dsn: config.sentryDsn,
    sendDefaultPii: true,
    integrations: [tanstackRouterBrowserTracingIntegration(router), replayIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
};

render();
// Load toastify CSS after first paint to avoid render-blocking
requestAnimationFrame(() => {
  void import("react-toastify/dist/ReactToastify.css");
  void import("./main.css");
});
initializeAnalytics();
initializeSentry();
